import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { Button, Text } from 'ui_2';

export const GetProButton = ({
  action = 'Purchase',
}: {
  action?: 'Purchase' | 'Enter';
}) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  return (
    <Button
      onClick={() =>
        isPuzzleWalletWebview
          ? window.open('https://app.puzzle.online/paywall', '_blank')
          : // @ts-ignore
            window?.aleo?.puzzleWalletClient?.openGoProRoute?.query?.()
      }
      size='md'
      variant='black'
      className='items-center gap-2'
      fullWidth
    >
      <Text className='rounded-full bg-secondary-yellow px-2' font='sm'>
        PRO
      </Text>
      Get Pro to {action}
    </Button>
  );
};
